module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/trophy-brigade-lvl1-100.bee1dac3.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/trophy-brigade-lvl1-100.png
// module id = 3579
// module chunks = 11